import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconColorPro = function IconColorPro(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 37,
    height: 16,
    viewBox: "0 0 37 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-color-pro"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: 37,
    height: 16,
    rx: 8,
    fill: "#FFA310"
  }), /*#__PURE__*/React__default.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.2091 4.14679H8V11.8532H9.5869V9.26747H11.1914C12.9194 9.26747 13.9186 8.18349 13.9186 6.7156C13.9186 5.27029 12.9311 4.14679 11.2091 4.14679ZM12.3023 6.7156C12.3023 7.76006 11.6381 8.07057 10.5332 8.07057H9.58102V5.36062H10.9034C11.7792 5.36062 12.3023 5.8518 12.3023 6.7156Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M18.2443 4.14679H15.0411V11.8532H16.6045V8.97953H18.0327L19.4374 11.8532H21.2124L19.5961 8.74806C20.2074 8.51658 21.0596 7.85039 21.0596 6.58574C21.0596 5.22512 20.1486 4.14679 18.2443 4.14679ZM16.6045 7.83345V5.34368H18.0151C18.8321 5.34368 19.4198 5.76711 19.4198 6.61397C19.4198 7.41002 18.885 7.83345 17.9916 7.83345H16.6045Z",
    fill: "#000A23"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M29 8.52223V7.53423C29 5.35498 27.7187 4 25.5676 4C23.4282 4 22.1234 5.34368 22.1234 7.53423V8.52223C22.1234 10.6958 23.4106 12 25.5558 12C27.7011 12 29 10.6958 29 8.52223ZM27.3896 7.52294V8.52788C27.3896 10.0127 26.6255 10.7297 25.5617 10.7297C24.5038 10.7297 23.7397 10.0127 23.7397 8.52788V7.52294C23.7397 6.03811 24.5038 5.27029 25.5617 5.27029C26.6255 5.27029 27.3896 6.03811 27.3896 7.52294Z",
    fill: "#000A23"
  }))));
};

export { IconColorPro };
